import * as Sentry from '@sentry/react'
import { useEffect } from 'react'

export const useSentry = () => {
    useEffect(() => {
        if (!Sentry) {
            console.warn('Sentry has not been initialized')
        }
    }, [])

    return Sentry
}
